import script from "./Topic.vue?vue&type=script&setup=true&lang=js"
export * from "./Topic.vue?vue&type=script&setup=true&lang=js"

import "./Topic.vue?vue&type=style&index=0&id=08f485d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08f485d6"]])

export default __exports__